import { useParentOrigin } from './useParentOrigin';

const { outboundTargetOrigin } = useParentOrigin();

function postToParent(payload: unknown) {
    if (typeof window === 'undefined' || window.parent === window) {
        return;
    }
    window.parent.postMessage(JSON.stringify(payload), outboundTargetOrigin());
}

export function postConfigurationSavedToParent(payload: {
    recordId?: string;
    customerId?: string;
    name: string;
    screenshots: { label: string; dataUrl: string }[];
}) {
    if (typeof window === 'undefined' || window.parent === window) {
        return;
    }
    const message: Record<string, unknown> = {
        eventType: 'configurationSaved',
        Name: payload.name,
        Screenshots: payload.screenshots.map(({ label, dataUrl }) => ({ label, dataUrl }))
    };
    if (payload.recordId) {
        message.RecordID = payload.recordId;
    }
    if (payload.customerId) {
        message.CustomerID = payload.customerId;
    }
    postToParent(message);
}

export function usePostMessage() {
    function askEcommerceProduct(handle: string) {
        postToParent({ eventType: 'askEcommerceProduct', handle });
    }

    function askEcommerceCustomerId() {
        postToParent({ eventType: 'askCustomerId' });
    }

    function askRedirect(url: string) {
        postToParent({ eventType: 'redirect', url });
    }

    function askVariantsData(variantRefs: string[], productHandle?: string) {
        postToParent({ eventType: 'askVariantsData', variantRefs, productHandle });
    }

    function askParentUrl() {
        postToParent({ eventType: 'askParentUrl' });
    }

    return {
        askEcommerceProduct,
        askEcommerceCustomerId,
        askRedirect,
        askVariantsData,
        askParentUrl
    };
}
